function ErrorMessage(props) {
	return (
		<section className='form-alert form-alert-error w-full my-5 text-grey-900'>
			{props.heading}
			<div className='text rich-text'>{props.message}</div>
		</section>
	);
}

export default ErrorMessage;
